import { render, staticRenderFns } from "./SafeDigWhatsNew.vue?vue&type=template&id=f78f165a&scoped=true"
import script from "./SafeDigWhatsNew.vue?vue&type=script&lang=js"
export * from "./SafeDigWhatsNew.vue?vue&type=script&lang=js"
import style0 from "./SafeDigWhatsNew.vue?vue&type=style&index=0&id=f78f165a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f78f165a",
  null
  
)

export default component.exports